export const specialIncreasedBets = {
		superOdds : {},
		extraOdds : {},
		getBet : function (scomSogei, handicap){
			const key = [scomSogei, handicap].join("_");
			return this.superOdds[key]? this.superOdds[key] : this.extraOdds[key];
		}
};
